/**
 * Resuelve la URL completa de imagen de producto/categoría/marca/blog para
 * mostrar previews en el admin. La BD guarda solo el nombre del archivo;
 * estas funciones le anteponen el CDN. Mismo comportamiento que
 * `apps/web/lib/product-image.ts` pero usando `import.meta.env` (Vite).
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const env: Record<string, string | undefined> = (import.meta as any).env || {}

// El dominio de producción es mazautopartes.com.mx. El antiguo CDN
// www.mazautopartes.net/fotos/* responde 403 Forbidden, así que el fallback
// por defecto apunta al dominio nuevo (donde Next sirve /uploads/* directo).
const CDN_BASE = env.VITE_IMAGE_CDN || 'https://mazautopartes.com.mx/uploads'
const IMAGE_BASE_PRODUCTS = env.VITE_IMAGE_CDN_PRODUCTS || `${CDN_BASE}/productos`
const IMAGE_BASE_CATEGORIES = env.VITE_IMAGE_CDN_CATEGORIES || `${CDN_BASE}/categorias`
const IMAGE_BASE_BRANDS = env.VITE_IMAGE_CDN_BRANDS || `${CDN_BASE}/marcas`
const IMAGE_BASE_BLOG = env.VITE_IMAGE_CDN_BLOG || `${CDN_BASE}/blog`

const PLACEHOLDER = '/img/sin-imagen.jpg'
const EMPTY_TOKENS = new Set(['', '0', 'null', 'NULL', 'undefined', 'na', 'N/A'])

function resolve(image: string | null | undefined, base: string): string {
  if (!image) return PLACEHOLDER
  const trimmed = image.trim()
  if (EMPTY_TOKENS.has(trimmed)) return PLACEHOLDER
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  // /uploads/... viene del uploader del admin (servido por Next public/)
  if (trimmed.startsWith('/')) return trimmed
  return `${base}/${encodeURIComponent(trimmed)}`
}

export function productImageUrl(image: string | null | undefined): string {
  return resolve(image, IMAGE_BASE_PRODUCTS)
}

export function categoryImageUrl(image: string | null | undefined): string {
  return resolve(image, IMAGE_BASE_CATEGORIES)
}

export function brandImageUrl(image: string | null | undefined): string {
  return resolve(image, IMAGE_BASE_BRANDS)
}

export function blogImageUrl(image: string | null | undefined): string {
  return resolve(image, IMAGE_BASE_BLOG)
}
